import { RowGroup } from './RowGroup'

export const TBodyCustom = ({
  ids,
  schema,
  selectRowGroup,
  selectCellData,
  changeActiveRow,
  activeRowGroupId,
  isDynamicReport,
}) => {
  return (
    <tbody>
      {ids.map((rowId, index) => {
        return (
          <RowGroup
            key={rowId}
            activeRowGroupId={activeRowGroupId}
            schema={schema}
            rowId={rowId}
            rowGroupIndex={index}
            changeActiveRow={changeActiveRow}
            selectRowGroup={selectRowGroup}
            selectCellData={selectCellData}
            isDynamicReport={isDynamicReport}
          />
        )
      })}
    </tbody>
  )
}
